import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AuthGuard } from "@/lib/auth";
import { AppShell } from "@/components/layout/app-shell/app-shell";

export const Route = createFileRoute("/_authenticated")({
	component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
	const { i18n } = useTranslation();
	return (
		<AuthGuard>
			<AppShell>
				<Outlet key={i18n.resolvedLanguage} />
			</AppShell>
		</AuthGuard>
	);
}
